import { BaseItemSetParagraphSection } from '@exam-management/qcontent-management';
import { FormRichTextEditor } from '@exam-management/rich-text-editor';

import { useUploadImageForItemSetQuestionCreation } from '../../hooks';
import { ItemSetCreationParagraphReadonlySection } from '../item-set-creation-paragraph-readonly-section';

interface ItemSetCreationParagraphSectionProps {
  questionGroupId?: string;
  taskId: string;
  isEditable?: boolean;
}

export default function ItemSetCreationParagraphSection(
  props: Readonly<ItemSetCreationParagraphSectionProps>,
) {
  const { questionGroupId, taskId, isEditable = true } = props;
  const { handleUpload, loading: isLoading } = useUploadImageForItemSetQuestionCreation({
    questionGroupId,
    taskId,
  });

  return (
    <BaseItemSetParagraphSection>
      {isEditable ? (
        <FormRichTextEditor
          placeholder='กรอกบทความที่นี่'
          name='details.paragraph'
          rows={2}
          onImageUpload={handleUpload}
          loading={isLoading}
        />
      ) : (
        <ItemSetCreationParagraphReadonlySection taskId={taskId} />
      )}
    </BaseItemSetParagraphSection>
  );
}
